/* Noro Giveaway
   1. Country picker (/pages/giveaway): carries UTM and click ids over to the chosen page.
   2. Signup form (/pages/giveaway-rs, /pages/giveaway-eu): validates the designed form and
      posts it to Klaviyo's public Client Subscriptions API, using the account (company_id)
      and list configured on the section. RS and EU use different Klaviyo accounts, so the
      form never relies on the Klaviyo onsite script that noro.rs already loads. */
(function () {
  'use strict';

  if (window.__noroGiveaway) return;
  window.__noroGiveaway = true;

  var API = 'https://a.klaviyo.com/client/subscriptions/?company_id=';
  var REVISION = '2025-10-15';
  var TIMEOUT_MS = 15000;
  var CARRY = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id', 'fbclid', 'gclid', 'ttclid'];
  var UTM = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  var EMAIL_RE = /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)*\.[A-Za-z]{2,}$/;

  var MSG = {
    phoneEmpty: 'Unesi broj telefona.',
    phoneBad: 'Broj telefona nije ispravan. Primer: ',
    emailEmpty: 'Unesi email adresu.',
    emailBad: 'Email adresa nije ispravna.',
    emailRejected: 'Ova email adresa nije prihvaćena. Proveri je i pokušaj ponovo.',
    consent: 'Za učešće je potrebno da prihvatiš pravila nagradne igre.',
    failed: 'Prijava trenutno nije uspela. Proveri internet vezu i pokušaj ponovo.',
    config: 'Forma još nije podešena (nedostaje Klaviyo nalog ili lista).',
    busy: 'ŠALJEM…'
  };

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function query() {
    try { return new URLSearchParams(window.location.search); } catch (e) { return null; }
  }

  /* ---------- 1. Country picker ---------- */

  function initPicker(root) {
    if (root.getAttribute('data-bound') === '1') return;
    root.setAttribute('data-bound', '1');
    var current = query();
    if (!current) return;
    var links = root.querySelectorAll('a[data-country-link]');
    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      var href = link.getAttribute('href');
      if (!href || href === '#') continue;
      try {
        var url = new URL(href, window.location.origin);
        var changed = false;
        CARRY.forEach(function (key) {
          var value = current.get(key);
          if (value && !url.searchParams.has(key)) {
            url.searchParams.set(key, value);
            changed = true;
          }
        });
        if (!changed) continue;
        link.setAttribute('href', url.origin === window.location.origin ? url.pathname + url.search + url.hash : url.toString());
      } catch (e) { /* keep the original link */ }
    }
  }

  /* ---------- 2. Signup form ---------- */

  function readConfig(root) {
    var node = root.querySelector('script[data-noro-gw-config]');
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (e) { return null; }
  }

  function findCountry(cfg, code) {
    var list = cfg.countries || [];
    code = String(code || '').toUpperCase();
    for (var i = 0; i < list.length; i++) if (list[i].code === code) return list[i];
    return null;
  }

  /* National or international input -> E.164, or null when it cannot be a phone number. */
  function toE164(raw, dial) {
    var value = String(raw || '').trim();
    if (!value) return '';
    var cc = String(dial || '').replace(/\D/g, '');
    var international = /^(\+|00)/.test(value);
    var digits = value.replace(/\D/g, '');
    if (/^00/.test(value)) digits = digits.slice(2);
    if (!international && cc && digits.indexOf(cc) === 0 && digits.length >= cc.length + 8) international = true;
    if (international) {
      if (cc && digits.indexOf(cc) === 0 && digits.charAt(cc.length) === '0') {
        digits = cc + digits.slice(cc.length).replace(/^0+/, '');
      }
      return digits.length >= 8 && digits.length <= 15 ? '+' + digits : null;
    }
    digits = digits.replace(/^0+/, '');
    if (digits.length < 7 || digits.length > 10) return null;
    return '+' + cc + digits;
  }

  function initForm(root) {
    if (root.getAttribute('data-bound') === '1') return;
    var cfg = readConfig(root);
    var form = root.querySelector('[data-form]');
    if (!cfg || !form) return;
    root.setAttribute('data-bound', '1');

    var done = root.querySelector('[data-done]');
    var phone = form.querySelector('input[name="phone"]');
    var email = form.querySelector('input[name="email"]');
    var consent = form.querySelector('input[name="consent"]');
    var trap = form.querySelector('input[name="company"]');
    var select = form.querySelector('[data-country-select]');
    var dialText = form.querySelector('[data-dial-text]');
    var alertBox = form.querySelector('[data-alert]');
    var submit = form.querySelector('[data-submit]');
    var ctaLabel = form.querySelector('[data-cta-label]');
    var ctaText = ctaLabel ? ctaLabel.textContent : '';
    var busy = false;

    var params = query();
    var country = findCountry(cfg, params && params.get('country')) || findCountry(cfg, cfg.defaultCountry) || (cfg.countries || [])[0];

    function applyCountry(next, fromUser) {
      if (!next) return;
      country = next;
      if (dialText) dialText.textContent = country.dial;
      if (phone && country.placeholder) phone.placeholder = country.placeholder;
      if (select && select.value !== country.code) select.value = country.code;
      root.setAttribute('data-country', country.code);
      if (fromUser && select) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('country', country.code);
          window.history.replaceState(window.history.state, '', url);
        } catch (e) { /* not important */ }
        if (phone && phone.getAttribute('aria-invalid') === 'true') checkPhone();
      }
    }

    applyCountry(country, false);
    if (select) {
      select.addEventListener('change', function () {
        applyCountry(findCountry(cfg, select.value), true);
      });
    }

    function errorNode(name) {
      return form.querySelector('[data-error-for="' + name + '"]');
    }

    function setError(input, name, message) {
      var node = errorNode(name);
      if (message) {
        if (input) input.setAttribute('aria-invalid', 'true');
        if (node) { node.textContent = message; node.hidden = false; }
      } else {
        if (input) input.removeAttribute('aria-invalid');
        if (node) { node.textContent = ''; node.hidden = true; }
      }
    }

    function checkPhone() {
      var value = toE164(phone.value, country.dial);
      if (value === '') { setError(phone, 'phone', MSG.phoneEmpty); return null; }
      if (!value) { setError(phone, 'phone', MSG.phoneBad + country.dial + ' ' + country.placeholder); return null; }
      setError(phone, 'phone', '');
      return value;
    }

    function checkEmail() {
      var value = String(email.value || '').trim();
      if (!value) { setError(email, 'email', MSG.emailEmpty); return null; }
      if (!EMAIL_RE.test(value)) { setError(email, 'email', MSG.emailBad); return null; }
      setError(email, 'email', '');
      return value.toLowerCase();
    }

    function checkConsent() {
      if (!consent || !cfg.consentRequired || consent.checked) { setError(consent, 'consent', ''); return true; }
      setError(consent, 'consent', MSG.consent);
      return false;
    }

    phone.addEventListener('input', function () { if (phone.getAttribute('aria-invalid') === 'true') checkPhone(); });
    phone.addEventListener('blur', function () { if (phone.value.trim()) checkPhone(); });
    email.addEventListener('input', function () { if (email.getAttribute('aria-invalid') === 'true') checkEmail(); });
    email.addEventListener('blur', function () { if (email.value.trim()) checkEmail(); });
    if (consent) consent.addEventListener('change', function () { if (consent.checked) setError(consent, 'consent', ''); });

    function showAlert(message) {
      if (!alertBox) return;
      alertBox.textContent = message || '';
      alertBox.hidden = !message;
    }

    function setBusy(state) {
      busy = state;
      form.setAttribute('aria-busy', state ? 'true' : 'false');
      if (submit) submit.disabled = state;
      if (ctaLabel) ctaLabel.textContent = state ? MSG.busy : ctaText;
    }

    function showDone() {
      form.hidden = true;
      if (!done) return;
      done.hidden = false;
      try { done.focus({ preventScroll: true }); } catch (e) { done.focus(); }
      var box = done.getBoundingClientRect();
      if (box.top < 0 || box.bottom > window.innerHeight) {
        done.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (busy) return;
      showAlert('');

      var phoneValue = checkPhone();
      var emailValue = checkEmail();
      var consentOk = checkConsent();
      if (!phoneValue || !emailValue || !consentOk) {
        var first = form.querySelector('[aria-invalid="true"]');
        if (first) first.focus();
        return;
      }

      if (trap && trap.value) { showDone(); return; }
      if (!cfg.companyId || !cfg.listId) { showAlert(MSG.config); return; }

      var entry = {
        email: emailValue,
        phone: phoneValue,
        consent: consent ? consent.checked : true,
        country: country,
        properties: buildProperties(cfg, country, phoneValue)
      };

      setBusy(true);
      subscribe(cfg, entry).then(function (result) {
        setBusy(false);
        if (result.ok) {
          root.setAttribute('data-signup', result.step);
          showDone();
          afterSignup(root, cfg, entry);
          return;
        }
        if (result.field === 'email') {
          setError(email, 'email', MSG.emailRejected);
          email.focus();
          return;
        }
        showAlert(MSG.failed);
      });
    });
  }

  function buildProperties(cfg, country, phoneValue) {
    var props = {
      giveaway_campaign: cfg.campaign,
      giveaway_market: String(cfg.market || '').toUpperCase(),
      giveaway_country_code: country.code,
      giveaway_country_name: country.name,
      giveaway_phone: phoneValue,
      giveaway_page: window.location.pathname,
      giveaway_signup_at: new Date().toISOString()
    };
    var params = query();
    if (params) {
      UTM.forEach(function (key) {
        var value = params.get(key);
        if (value) props['giveaway_' + key] = value.slice(0, 200);
      });
    }
    return props;
  }

  /* Sends the subscription. If Klaviyo rejects the SMS consent or the phone number
     (4xx), the next attempt drops that part so the email signup still goes through;
     the phone stays on the profile as giveaway_phone either way. */
  function subscribe(cfg, entry) {
    var steps = [];
    var wantSms = !!(cfg.smsConsent && entry.consent);
    if (wantSms) steps.push({ name: 'email+phone+sms', phone: true, sms: true });
    steps.push({ name: 'email+phone', phone: true, sms: false });
    steps.push({ name: 'email', phone: false, sms: false });

    var index = 0;
    var retried = false;

    function attempt() {
      var step = steps[index];
      return post(cfg, payload(cfg, entry, step)).then(function (res) {
        if (res.ok) return { ok: true, step: step.name };
        if (res.status === 0 || res.status === 429 || res.status >= 500) {
          if (retried) return { ok: false };
          retried = true;
          return wait(1200).then(attempt);
        }
        if (res.emailError) return { ok: false, field: 'email' };
        index += 1;
        if (index < steps.length) return attempt();
        return { ok: false };
      });
    }

    return attempt();
  }

  function payload(cfg, entry, step) {
    var attributes = {
      email: entry.email,
      properties: entry.properties,
      subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
    };
    if (step.phone) attributes.phone_number = entry.phone;
    if (step.sms) attributes.subscriptions.sms = { marketing: { consent: 'SUBSCRIBED' } };
    var source = cfg.source || 'Noro Giveaway';
    if (cfg.market === 'eu') source += ' · ' + entry.country.code;
    return {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: source,
          profile: { data: { type: 'profile', attributes: attributes } }
        },
        relationships: {
          list: { data: { type: 'list', id: cfg.listId } }
        }
      }
    };
  }

  function post(cfg, body) {
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = controller ? window.setTimeout(function () { controller.abort(); }, TIMEOUT_MS) : null;
    return window.fetch(API + encodeURIComponent(cfg.companyId), {
      method: 'POST',
      mode: 'cors',
      credentials: 'omit',
      headers: {
        'Content-Type': 'application/vnd.api+json',
        Accept: 'application/vnd.api+json',
        revision: REVISION
      },
      body: JSON.stringify(body),
      signal: controller ? controller.signal : undefined
    }).then(function (response) {
      if (timer) window.clearTimeout(timer);
      if (response.status >= 200 && response.status < 300) return { ok: true, status: response.status };
      return response.text().then(function (text) {
        var json = null;
        try { json = JSON.parse(text); } catch (e) { /* not JSON */ }
        return { ok: false, status: response.status, emailError: isEmailError(json) };
      }, function () {
        return { ok: false, status: response.status, emailError: false };
      });
    }, function () {
      if (timer) window.clearTimeout(timer);
      return { ok: false, status: 0 };
    });
  }

  function isEmailError(json) {
    var errors = json && json.errors;
    if (!errors || !errors.length) return false;
    for (var i = 0; i < errors.length; i++) {
      var err = errors[i] || {};
      var pointer = (err.source && err.source.pointer) || '';
      if (/\/email$/.test(pointer)) return true;
      var text = (err.detail || '') + ' ' + (err.title || '');
      if (/email/i.test(text) && !/phone|sms/i.test(text)) return true;
    }
    return false;
  }

  function wait(ms) {
    return new Promise(function (resolve) { window.setTimeout(resolve, ms); });
  }

  function afterSignup(root, cfg, entry) {
    var market = String(cfg.market || '').toUpperCase();
    var detail = { market: market, country: entry.country.code, campaign: cfg.campaign };

    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'noro_giveaway_signup', giveaway_market: market, giveaway_country: entry.country.code, giveaway_campaign: cfg.campaign });
    } catch (e) { /* ignore */ }
    try {
      if (typeof window.fbq === 'function') window.fbq('track', 'Lead', { content_name: 'Noro Giveaway', content_category: market + ' ' + entry.country.code });
    } catch (e) { /* ignore */ }
    try {
      if (window.ttq && typeof window.ttq.track === 'function') window.ttq.track('SubmitForm', { content_name: 'Noro Giveaway' });
    } catch (e) { /* ignore */ }
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('noro_giveaway_signup', detail);
      }
    } catch (e) { /* ignore */ }

    /* Only for the RS page: noro.rs already runs the RS Klaviyo onsite script, so identify
       ties this browser to the new profile. Never on EU, it would land in the RS account. */
    if (cfg.identifyOnsite && cfg.market === 'rs') {
      try {
        var k = window.klaviyo;
        if (k && typeof k.identify === 'function') k.identify({ email: entry.email });
        else if (k && typeof k.push === 'function') k.push(['identify', { $email: entry.email }]);
      } catch (e) { /* ignore */ }
    }

    try {
      root.dispatchEvent(new CustomEvent('noro:giveaway-signup', { bubbles: true, detail: detail }));
    } catch (e) { /* ignore */ }
  }

  /* ---------- boot ---------- */

  function boot(scope) {
    var base = scope && scope.querySelectorAll ? scope : document;
    var pickers = base.querySelectorAll('[data-noro-gw-picker]');
    for (var i = 0; i < pickers.length; i++) initPicker(pickers[i]);
    var forms = base.querySelectorAll('[data-noro-gw]');
    for (var j = 0; j < forms.length; j++) initForm(forms[j]);
  }

  ready(function () { boot(document); });
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });

  /* Exposed for tests only. */
  window.NoroGiveaway = { toE164: toE164 };
})();
